var map = {
	"./facebook.png": "1Mne",
	"./instagram.png": "cDEH",
	"./tiktok.png": "GP38",
	"./twitch.png": "zH2c",
	"./twitter.png": "q2ri",
	"./youtube.png": "loU3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UtoT";


//////////////////
// WEBPACK FOOTER
// ./src/assets/platforms ^\.\/.*\.png$
// module id = UtoT
// module chunks = 1